import { axiosRequest } from '../../service';
import { REACT_APP_VAM_CONTEXT_LITIGATION, REACT_APP_VAM_ENDPOINT } from '../../urls';

// Function to fetch the list of litigations for a claim
export const getLitigationLists = async (claimId) => {
    try {
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/litigationList/${claimId}`);
        return response.data;
    } catch (error) {
        throw error; // Re-throw to be handled by the caller
    }
};

// Function to create a new litigation record
export const createClaimLitigation = async (litigationData) => {
    try {
        const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/litigation`, litigationData);
        return response.data;
    } catch (error) {
        throw error;
    }
};
// Function to fetch the list of getLegalExpense for a claim
export const getLegalExpenses = async (claimId) => {
    try {
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/legal-expenses/${claimId}`);
        return response.data;
    } catch (error) {
        throw error; // Re-throw to be handled by the caller
    }
};
// Function to create a new legal expense record
export const createLegalExpense = async (legalExpenses) => {
    try {
        const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/legal-expenses`, legalExpenses); // Corrected endpoint
        return response.data;
    } catch (error) {
        throw error;
    }
};
// Function to fetch potential litigation details
export const fetchPotentialLitigationDetails = async (claimId) => {
    try {
        const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/potential-litigation/${claimId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
// Function to flag a record as potential litigation
export const updatePotentialLitigation = async (potentialLitigation) => {
    try {
        const response = await axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/potential-litigation`, potentialLitigation);
        return response.data;
    } catch (error) {
        throw error;
    }
};